const ModuleConfig = {
    "primaryKey": "id",
    "formDefaultValue" : {
        "name" : ""
    },
    "formFields": {
        "name": {
            "label": "Name",
            "isRequired": false,
            "colWidth": "col-md-6",
            "inputType": "text",
            "type" :"text"
        },
        "merchant_id": {
            "label": "Select Merchant",
            "placeholder": "Select Merchant",
            "hideFor": "Merchant",
            "isRequired": false,
            "colWidth": "col-md-6",
            "inputType": "select",
            "asynchLoad": true,
            "dataUrl": "/merchants",
            "keyValue": "id",
            "keylabel": "name",
            "options": [{
                value: "Test",
                label: "Test"
            }],
            "type": "text"
        },
        "image": {
            "label": "Image",
            "isRequired": false,
            "colWidth": "col-md-6",
            "inputType": "file",
            "type" :"file"
        },
        "status": {
            "label": "Status",
            "isRequired": false,
            "colWidth": "col-md-6",
            "inputType": "select",
            "type" :"select",
            "placeholder":"Select Status",
            "options" : [{
                "label" : "Active",
                "value" : "Active"
            }, {
                "label" : "Inactive",
                "value" : "Inactive"
            }]
        }
    },
    "listColumnOrder": [
        "name",
        "image",
        "status"    
    ]
}

export default ModuleConfig